export enum CategoryMenu {
  PRINCIPAL = 'principal',
  USER_MENU = 'user_menu',
  LOGIN_MENU = 'login_menu',
}
